(() => {
  const bannerSlider = () => {
    if (typeof Swiper === "undefined") return;

    const sliders = document.querySelectorAll(".js-slider-simple");
    if (!sliders.length) return;

    sliders.forEach((container) => {
      const slider = container.querySelectorAll(".swiper")[0];

      new Swiper(slider, {
        loop: true,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: container.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: container.querySelector(".swiper-button-next"),
          prevEl: container.querySelector(".swiper-button-prev"),
        },
      });
    });
  };

  const commonSliderMobile = () => {
    if (typeof Swiper === "undefined") return;

    const containers = document.querySelectorAll(".js-slider-mobile");
    if (!containers.length) return;

    containers.forEach((container) => {
      const sliderEl = container.querySelector(".swiper");
      if (!sliderEl) return;

      const delay =
        parseInt(sliderEl.getAttribute("data-slider-delay")) || 4000;
      let swiper = null;

      const isMobile = () => window.matchMedia("(max-width: 767.98px)").matches;

      const initSwiper = () => {
        if (swiper) return;

        swiper = new Swiper(sliderEl, {
          slidesPerView: 2,
          spaceBetween: 20,
          speed: 600,
          loop: true,
          autoplay: {
            delay: delay,
            disableOnInteraction: false,
          },
        });
      };

      const destroySwiper = () => {
        if (!swiper) return;

        swiper.destroy(true, true);
        swiper = null;
      };

      const handle = () => {
        if (isMobile()) {
          initSwiper();
        } else {
          destroySwiper();
        }
      };

      // debounce resize
      let resizeTimer;
      const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handle, 200);
      };

      handle();
      window.addEventListener("resize", onResize);
    });
  };

  const filterAll = () => {
    const minInput = document.getElementById('range-min');
    const maxInput = document.getElementById('range-max');
    const container = document.querySelector('.collection-content');

    if (!container) return;

    let debounceTimer;
    let controller;

    const getStockInputs = () =>
      document.querySelectorAll('.block-filter input[type="checkbox"]');

    const getCategoryInputs = () =>
      document.querySelectorAll('.filter-category:checked');

    const updateProducts = async () => {
      const stockInputs = getStockInputs();
      const categoryInputs = getCategoryInputs();

      const selectedStock = Array.from(stockInputs)
        .filter(i => i.checked)
        .map(i => i.value);

      const selectedCategories = Array.from(categoryInputs).map(i => i.value);

      if (!selectedCategories.length) return;

      if (controller) controller.abort();
      controller = new AbortController();

      container.style.opacity = '0.5';

      try {
        // 🔥 fetch nhiều collection
        const responses = await Promise.all(
          selectedCategories.map(url =>
            fetch(url, {
              signal: controller.signal,
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            }).then(res => res.text())
          )
        );

        let allProducts = [];

        responses.forEach(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('.product-grid__item');
          allProducts.push(...items);
        });

        // 🔥 filter stock
        if (selectedStock.length) {
          allProducts = allProducts.filter(item => {
            const isAvailable = item.innerHTML.includes('In stock');
            return selectedStock.includes(isAvailable ? '1' : '0');
          });
        }

        // 🔥 render lại
        const grid = document.createElement('ul');
        grid.className = 'product-grid';
        grid.setAttribute('product-grid-view', 'default');

        allProducts.forEach(el => {
          grid.appendChild(el);
        });

        container.innerHTML = '';
        container.appendChild(grid);

        requestAnimationFrame(() => {
          container.style.opacity = '1';
        });

      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    };

    const debounceUpdate = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateProducts, 300);
    };

    // event
    [minInput, maxInput].forEach(i => {
      i?.addEventListener('input', debounceUpdate);
    });

    getStockInputs().forEach(i => {
      i.addEventListener('change', debounceUpdate);
    });

    document.querySelectorAll('.filter-category').forEach(i => {
      i.addEventListener('change', debounceUpdate);
    });
  };

  const syncFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const values = params.getAll('filter.v.availability');

    document.querySelectorAll('.block-filter input').forEach(input => {
      input.checked = values.includes(input.value);
    });
  };

  commonSliderMobile();
  bannerSlider();
  filterAll();
  syncFromUrl();
})();
